import React from 'react';
import { Link } from 'react-router-dom';
import { ForumPost } from '../../models/ForumPost';
import { AGE_RANGE_TEXTS, BODY_FIGURE_TEXTS, HEIGHT_RANGE_TEXTS } from '../../consts';
import './DonorRecruitmentCard.scss';

type Props = {
  post: ForumPost;
};

function relTime(isoStr: string): string {
  const diff = Date.now() - new Date(isoStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'たった今';
  if (mins < 60) return `${ mins }分前`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${ hours }時間前`;
  if (hours < 48) {
    const d = new Date(isoStr);
    return `昨日 ${ String(d.getHours()).padStart(2, '0') }:${ String(d.getMinutes()).padStart(2, '0') }`;
  }
  return `${ Math.floor(hours / 24) }日前`;
}

const DonorRecruitmentCard = ({ post }: Props) => {
  const isNew = !!post.postedAt && Date.now() - new Date(post.postedAt).getTime() < 24 * 60 * 60 * 1000;
  const isUrgent = post.daysLeft <= 20;
  const deadlineRel = `あと${ post.daysLeft }日`;

  return (
    <li className="rec-card">
      <div className="top-row">
        <div className="meta-stack">
          <div className="author-line">
            <strong>{ post.doneeNameF }様</strong>
            <span className="dot" />
            <span>{ post.doneeAgeText }</span>
            { isNew && <span className="new-pill">NEW</span> }
          </div>
          <div className="sub-meta">
            <span>投稿 <strong>{ post.postedAt ? relTime(post.postedAt) : '—' }</strong></span>
            <span className="dot" />
            <span>
              締切 <strong>{ post.expiresAtText || '-' }</strong>
              { post.expiresAt && (
                <em className={ `countdown${ isUrgent ? ' urgent' : '' }` }>{ deadlineRel }</em>
              ) }
            </span>
          </div>
        </div>
        <div className="right-meta">
          <div className="apps">
            <span className="num">{ post.applicationsCount }<span className="cap">/20</span></span>
            <span className="lbl">人 応募中</span>
          </div>
        </div>
      </div>

      { post.description && <p className="comment">{ post.description }</p> }

      <div className="conditions">
        <h4>募集内容</h4>
        <dl>
          <dt>エリア</dt>
          <dd><span className="chip">{ post.areaText }</span></dd>

          { post.bloodTypeChips.length > 0 && (
            <>
              <dt>血液型</dt>
              <dd>{ post.bloodTypeChips.map(v => <span key={ v } className="chip">{ v }</span>) }</dd>
            </>
          ) }

          { post.ageRange?.length && (
            <>
              <dt>年齢</dt>
              <dd>{ post.ageRange.map(k => <span key={ k } className="chip">{ AGE_RANGE_TEXTS[k] || k }</span>) }</dd>
            </>
          ) }

          { post.bodyFigure?.length && (
            <>
              <dt>体型</dt>
              <dd>{ post.bodyFigure.map(k => <span key={ k } className="chip">{ BODY_FIGURE_TEXTS[k] || k }</span>) }</dd>
            </>
          ) }

          { post.heightRange?.length && (
            <>
              <dt>身長</dt>
              <dd>{ post.heightRange.map(k => <span key={ k } className="chip">{ HEIGHT_RANGE_TEXTS[k] || k }</span>) }</dd>
            </>
          ) }
        </dl>
      </div>

      <div className="actions">
        <Link to={ `/forum/${ post.id }` } className="btn btn-fill">詳細を見る</Link>
      </div>
    </li>
  );
};

export default DonorRecruitmentCard;
